document.addEventListener('DOMContentLoaded', function() {
  const calculateBtn = document.getElementById('calculate-life-path');
  
  if (calculateBtn) {
    calculateBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const day = parseInt(document.getElementById('birth-day').value);
      const month = parseInt(document.getElementById('birth-month').value);
      const year = parseInt(document.getElementById('birth-year').value);
      
      if (!day || !month || !year) {
        alert('Please enter your complete birth date');
        return;
      }
      
      // Calculate Life Path Number
      function reduceToSingleDigit(num) {
        while (num > 9 && num !== 11 && num !== 22 && num !== 33) {
          num = num.toString().split('').reduce((a, b) => parseInt(a) + parseInt(b), 0);
        }
        return num;
      }
      
      const dayReduced = reduceToSingleDigit(day);
      const monthReduced = reduceToSingleDigit(month);
      const yearReduced = reduceToSingleDigit(year);
      
      let lifePathNumber = dayReduced + monthReduced + yearReduced;
      lifePathNumber = reduceToSingleDigit(lifePathNumber);
      
      // Display result
      const resultDiv = document.getElementById('life-path-result');
      if (resultDiv) {
        resultDiv.innerHTML = `<h2 style="color: gold; font-size: 3rem; margin: 2rem 0;">Your Life Path Number: ${lifePathNumber}</h2>`;
        resultDiv.scrollIntoView({ behavior: 'smooth' });
      }
      
      // Map to portal
      const portalMap = {
        11: '/collections/portal-11-master',
        77: '/collections/portal-77-spiritual-awakening',
        99: '/collections/portal-99-completion',
        111: '/collections/portal-111-trinity',
        33: '/collections/portal-33-ascension',
        1: '/collections/portal-11-master',
        2: '/collections/portal-77-spiritual-awakening',
        3: '/collections/portal-33-ascension',
        4: '/collections/portal-11-master',
        5: '/collections/portal-77-spiritual-awakening',
        6: '/collections/portal-99-completion',
        7: '/collections/portal-77-spiritual-awakening',
        8: '/collections/portal-99-completion',
        9: '/collections/portal-99-completion'
      };
      
      const portalUrl = portalMap[lifePathNumber];
      if (portalUrl && resultDiv) {
        resultDiv.innerHTML += `<p style="margin-top: 1rem;"><a href="${portalUrl}" style="color: gold; text-decoration: underline; font-size: 1.2rem;">Discover Your Portal →</a></p>`;
      }
    });
  }
});
